import React from "react";
import { ALLOCATION_TYPES, DISPLAY_MODE } from "Constants";
import { FormItem, FormSection } from "Components/form";
import { Row, Col, Input, Select } from "antd";
import FetchSelect from "Components/fetch-select";
import { Controller } from "react-hook-form";

export default function LodgingForm({ form, mode, errors, ...props }) {
  return (
    <FormSection title="Lojman Bilgileri">
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <FormItem htmlFor="taskDistinctionTitle" label="Görev Ayrım Unvanı">
            <FetchSelect
              api="/masterdata/taskdistinctiontitles"
              form={form}
              field="taskDistinctionTitle"
              readOnly={mode === DISPLAY_MODE.READ_ONLY}
              placeholder="Görev ayrım unvanı seçiniz"
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12}>
          <FormItem
            htmlFor="allocationType"
            label="Tahsis Türü"
            error={errors.allocationType}
            required={true}
          >
            <Controller
              control={form.control}
              name="allocationType"
              as={
                <Select
                  className={
                    mode === DISPLAY_MODE.readOnly ? "readOnly" : undefined
                  }
                >
                  {Object.entries(ALLOCATION_TYPES).map(([key, value]) => (
                    <Select.Option key={key} value={key}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12}>
          <FormItem label="Kat" required={true} error={errors.floor}>
            <Controller
              control={form.control}
              name="floor"
              as={
                <Input
                  placeholder="Kat giriniz"
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                />
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12}>
          <FormItem label="Daire" required={true} error={errors.flat}>
            <Controller
              control={form.control}
              name="flat"
              as={
                <Input
                  placeholder="Daire giriniz"
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                />
              }
            />
          </FormItem>
        </Col>
      </Row>
    </FormSection>
  );
}
